import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const navItem = ({ isActive }) =>
  `font-mono text-xs uppercase tracking-widest px-3 py-2 border-2 ${
    isActive ? "bg-ink text-cream border-ink" : "bg-white border-ink hover:bg-marker-yellow"
  }`;

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-cream border-b-2 border-ink" data-testid="top-nav">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3 flex-wrap">
        <Link to={user ? "/home" : "/"} className="flex items-center gap-2" data-testid="brand-link">
          <span className="bg-marker-red text-white font-display text-xl px-2 py-0.5 border-2 border-ink shadow-brutal-sm">
            #
          </span>
          <span className="font-display font-extrabold text-lg sm:text-xl tracking-tight">
            NoJobNoVC
          </span>
        </Link>

        <nav className="ml-auto flex items-center gap-2 flex-wrap">
          {user && user !== false ? (
            <>
              <NavLink to="/home" className={navItem} data-testid="nav-home">Feed</NavLink>
              <NavLink to="/strategies" className={navItem} data-testid="nav-strategies">Strategies</NavLink>
              <NavLink to="/forum" className={navItem} data-testid="nav-forum">Forum</NavLink>
              <NavLink to="/leaderboard" className={navItem} data-testid="nav-leaderboard">Leaderboard</NavLink>
              <NavLink to="/me" className={navItem} data-testid="nav-profile">My Profile</NavLink>
              <NavLink to="/pass" className={navItem} data-testid="nav-pass">Player Pass</NavLink>
              <button
                onClick={async () => { await logout(); window.location.href = "/"; }}
                className="brutal-btn brutal-btn-red text-sm"
                data-testid="logout-btn"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login" className={navItem} data-testid="nav-login">Log in</NavLink>
              <Link to="/register" className="brutal-btn brutal-btn-yellow text-sm" data-testid="nav-register">
                Join the challenge
              </Link>
            </>
          )}
        </nav>
      </div>
      <div className="bg-ink text-cream overflow-hidden border-t-2 border-ink">
        <div className="marquee-track py-1.5 whitespace-nowrap font-mono uppercase text-xs tracking-widest">
          {Array.from({ length: 2 }).map((_, i) => (
            <span key={i} className="flex gap-12 pr-12">
              <span>No Job.</span><span className="text-marker-yellow">No VC.</span>
              <span>No Family Money.</span><span className="text-marker-red">Just Grit.</span>
              <span>Build In Public.</span><span className="text-marker-yellow">Ship Or Stop Talking.</span>
              <span>Fund It Yourself.</span>
            </span>
          ))}
        </div>
      </div>
    </header>
  );
}
